import AsyncAutocomplete from './AsyncAutocomplete';
import { AUTOCOMPLETE_SEARCH_TYPE } from '../_const';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';

/**
 * Job Category search textbox
 * @param {string} key
 * @param {function} onchange
 * @param {function} onBlur
 * @param {boolean} error
 * @param {string} value
 * @param {string} name
 * @param {string} label
 * @param {boolean} disabled
 * @returns search textbox for job categories
 */
const JobCategoryAsyncAutocomplete2 = ({
	onchange,
	onBlur,
	error,
	value,
	name,
	id,
	label,
	disabled = false,
	formik,
	index,
	nameBase,
	onPush,
	onRemove,
}) => {
	return (
		<>
			{formik.values[nameBase][index] ? (
				<>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'flex-start',
						}}
					>
						<Typography sx={{ flexGrow: 1, pl: 1 }}>
							{formik.values[nameBase][index].label}
						</Typography>
						<Button
							variant='outlined'
							color='error'
							startIcon={<DeleteIcon />}
							onClick={() => onRemove(index)}
							sx={{ width: 220 }}
							disabled={disabled}
						>
							Remove
						</Button>
					</Box>

					<>
						{formik.values[nameBase].length === index + 1 &&
							index + 1 < 4 && (
								<Button
									variant='contained'
									color='success'
									startIcon={<AddIcon />}
									onClick={() => onPush('')}
									disabled={disabled}
								>
									Add New Job Category
								</Button>
							)}
					</>
				</>
			) : (
				<>
					<AsyncAutocomplete
						type={AUTOCOMPLETE_SEARCH_TYPE.JOB_CATEGORY}
						label={label}
						placeholder='Search for Job Category'
						handleChange={value => {
							onchange(value);
						}}
						sx={{ flexGrow: 1 }}
						error={error}
						value={value?.label}
						name={name}
						id={id}
						onBlur={onBlur}
						disabled={disabled}
						isOptionEqualToValue={(option, value) =>
							option.label === value ||
							option.label === value.label
						}
					/>

					<Button
						variant='contained'
						color='error'
						startIcon={<DeleteIcon />}
						onClick={() => {
							onRemove(index);
						}}
					>
						Cancel
					</Button>
				</>
			)}
		</>
	);
};

export default JobCategoryAsyncAutocomplete2;
